<template>
    <section class="course_info_page_wrp random_bgimg">
        <div class="course_info_section_inner">
            <div class="container-fluid">
                <div class="content_box_wrp">
                    <div class="course_info_top">
                        <h1 class="page_heading">Genetic Algorithms in Mathematical Finance (MLI215)</h1>
                        <p class="course_lead">Genetic Algorithms in Mathematical Finance is basic to Intermediate level
                            course, aimed at
                            undergraduates and graduate students which covers essential as well as many advanced level
                            concepts of Genetic Algorithm and how it can be used to solve complex problems in the field
                            of
                            computational mathematical finance. This program is delivered in Microsoft Excel/VBA rapid
                            application development (RAD) environment and Python. All topics are implemented in
                            Excel/VBA
                            and Python. This course includes detailed worked examples aimed at building an understanding
                            of
                            the genetic algorithm in depth.</p>
                        <div class="crs_label">
                            <label>Intermediate</label>
                        </div>
                        <p class="created_by">Created by <a href="#">Prince Tiwari</a></p>
                        <p class="created_by">Producer <a href="#">Risk Latte Americas Inc.</a></p>
                        <ul class="actn_list">
                            <li>Last updated 12/2024</li>
                            <li>English</li>
                            <li>English [CC], Arabic [Auto]</li>
                        </ul>
                    </div>
                    <div class="what_you_learn">
                        <div class="what_you_learn_inner">
                            <h3 class="section_heading">What you'll learn</h3>
                            <div class="row">
                                <div class="col-sm-6">
                                    <ul>
                                        <li>ChatGPT: Create content, synthesize information, and learn faster than ever
                                            with
                                            effective prompt engineering!</li>
                                        <li>Productivity: Achieve your goals faster with ChatGPT, manage your time,
                                            prioritize tasks, and create an optimized daily schedule!</li>
                                        <li>Soft Skills: Improve your communication, leadership, problem-solving, and
                                            social
                                            skills with personalized ChatGPT feedback!</li>
                                        <li>AI Video Tools: Create an AI avatar that transforms scripts into
                                            presentations
                                            and quickly generate social media content!</li>
                                    </ul>
                                </div>
                                <div class="col-sm-6">
                                    <ul>
                                        <li>ChatGPT: Create content, synthesize information, and learn faster than ever
                                            with
                                            effective prompt engineering!</li>
                                        <li>Productivity: Achieve your goals faster with ChatGPT, manage your time,
                                            prioritize tasks, and create an optimized daily schedule!</li>
                                        <li>Soft Skills: Improve your communication, leadership, problem-solving, and
                                            social
                                            skills with personalized ChatGPT feedback!</li>
                                        <li>AI Video Tools: Create an AI avatar that transforms scripts into
                                            presentations
                                            and quickly generate social media content!</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="related_topic_section">
                        <h3 class="section_heading">Explore related topics</h3>
                        <ul>
                            <li><label class="badge">ChatGPT</label></li>
                            <li><label class="badge">Other Office Productivity</label></li>
                            <li><label class="badge">Office Productivity</label></li>
                        </ul>
                    </div>
                    <div class="course_include_features">
                        <h3 class="section_heading">This course includes:</h3>
                        <div class="row">
                            <div class="col-sm-6">
                                <ul>
                                    <li><i class="fa fa-caret-right" aria-hidden="true"></i> 28 hours on-demand video</li>
                                    <li><i class="fa fa-caret-right" aria-hidden="true"></i> 21 articles</li>
                                    <li><i class="fa fa-caret-right" aria-hidden="true"></i> 76 downloadable resources</li>
                                    <li><i class="fa fa-caret-right" aria-hidden="true"></i> Access on mobile and TV</li>
                                </ul>
                            </div>
                            <div class="col-sm-6">
                                <ul>
                                    <li><i class="fa fa-caret-right" aria-hidden="true"></i> Closed captions</li>
                                    <li><i class="fa fa-caret-right" aria-hidden="true"></i> Audio description in existing audio</li>
                                    <li><i class="fa fa-caret-right" aria-hidden="true"></i> Certificate of completion</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="courses_content">
                        <div id="accordion">
                            <div class="card">
                                <div class="card-header" id="headingOne">
                                    <h5 class="mb-0"  data-toggle="collapse" data-target="#collapseOne"
                                    aria-expanded="true" aria-controls="collapseOne">
                                            Unique Features
                                    </h5>
                                </div>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                    data-parent="#accordion">
                                    <div class="card-body">
                                        <p>This course is an undergraduate level course aimed at the students in their
                                            freshman and sophomore years studying computer science, mathematics and
                                            computing, other branches of engineering. It introduces the subject of
                                            Genetic Algorithm (GA) from ground up and while explaining the essential
                                            features of GA, it primarily focuses on solving optimization problems,
                                            mostly used in mathematical finance, using GA. This is a non-Certification
                                            course, meaning that no stand-alone certification will be given in this
                                            course. However, students will earn Course Points (CP) in this course via
                                            their Lab Work, Tutorials, Assignments and Exam and these Course Points will
                                            count towards their overall certification in this Discipline (Category).
                                        </p>
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <ul>
                                                    <li>Delivered in Excel/VBA and Python with worked examples and
                                                        tutorials in Excel/VBA and Python.</li>
                                                    <li>Focus on mathematical optimization, with special emphasis on
                                                        optimization problems in finance, using Python and Excel/VBA
                                                    </li>
                                                    <li>Social Learning environment with self-study course materials
                                                        arranged in Modules and grading and performance measurement will
                                                        be via Course Points (CP).</li>
                                                </ul>
                                            </div>
                                            <div class="col-sm-4">
                                                <ul>
                                                    <li>In keeping with the philosophy of Open-ended Curriculum, the
                                                        subject matter and the course materials, including lecture
                                                        notes, Excel spreadsheets, VBA, and Python code will be
                                                        continuously added and enhanced to the Course repertoire.</li>
                                                    <li>Through Worked Examples the course will illustrate how to solve
                                                        optimization problems using Genetic Algorithm.</li>
                                                    <li>Genetic Algorithm will be employed in solving math problems like
                                                        Ordinary Differential Equations (ODEs), Systems of Linear
                                                        Equations, etc.</li>
                                                </ul>
                                            </div>
                                            <div class="col-sm-4">
                                                <ul>
                                                    <li>This is a non-Certification course which means that there will
                                                        be no stand-alone Certification for this course. However, all
                                                        Course Points (CP) earned in this course can be used for overall
                                                        certification process.</li>
                                                    <li>Regular assignments, online quizzes, Lab Work and tutorials will
                                                        form part of this course and the students will be able to earn
                                                        Course Points (CP) from these.</li>
                                                    <li>Another unique feature of this course will be that students will
                                                        be able to participate in or form study groups and mentor
                                                        circles which will be powered by Machine Learning and AI
                                                        algorithms.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="headingTwo">
                                    <h5 class="mb-0" data-toggle="collapse"
                                            data-target="#collapseTwo" aria-expanded="false"
                                            aria-controls="collapseTwo">
                                            Course Description
                                    </h5>
                                </div>
                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                    data-parent="#accordion">
                                    <div class="card-body">
                                        <p>Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                            richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard
                                            dolor
                                            brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
                                            tempor,
                                            sunt aliqua put a bird on it squid single-origin coffee nulla assumenda
                                            shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson
                                            cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                                            Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth
                                            nesciunt
                                            you probably haven't heard of them accusamus labore sustainable VHS.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="headingThree">
                                    <h5 class="mb-0" data-toggle="collapse"
                                            data-target="#collapseThree" aria-expanded="false"
                                            aria-controls="collapseThree">
                                            Certification
                                    </h5>
                                </div>
                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                    data-parent="#accordion">
                                    <div class="card-body">
                                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
                                        richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
                                        brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor,
                                        sunt aliqua put a bird on it squid single-origin coffee nulla assumenda
                                        shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson
                                        cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                                        Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt
                                        you probably haven't heard of them accusamus labore sustainable VHS.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="course_purchase_info">
                        <button class="btn btn-primary">EXPLORE COURSE</button>
                    </div>
                </div>
            </div>
        </div>
        <appFooter></appFooter>
    </section>
</template>



<script>
/* eslint-disable */
import { bus } from '@/main';

import appFooter from '@/components/public/common/footer/';
import variation_random_img1 from '@/assets/images/random_img/oddnary-variation-5.jpg';
import variation_random_img2 from '@/assets/images/random_img/oddnary-variation-7.jpg';
import variation_random_img3 from '@/assets/images/random_img/oddnary-variation-1.jpg';
import variation_random_img4 from '@/assets/images/random_img/oddnary-variation-4.jpg';
import variation_random_img5 from '@/assets/images/random_img/oddnary-variation-2.jpg';
import variation_random_img6 from '@/assets/images/random_img/oddnary-variation-6.jpg';
export default {
    name: 'course-info-by-slug',
    props: [],
    components: {
        appFooter
    },
    data() {
        return {
            courseCategory: []
        }
    },
    mounted() {
        bus.$emit('showHomeMenuBtn', true);
        this.randomImgLoaded();
    },
    methods: {
        randomImgLoaded() {
            const appLoader = document.querySelector('.app-loader');
            appLoader.style.display = 'block';

            // Multi Color Bg Img Of Section
            const images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6"];
            const variationImages = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4, variation_random_img5, variation_random_img6];
            const size = images.length;
            const x = Math.floor(size * Math.random());
            this.imageIndex = x;
            const element = document.getElementsByClassName('random_bgimg')[0];

            if (x < images.length) {
                const navbarListWrp = document.querySelector('.navbar_list_wrp');
                navbarListWrp.classList.add(`act_contest_clr_of_holders${x}`);
                element.style.backgroundImage = `url(${variationImages[x]})`;

                setTimeout(() => {
                    this.preloader = false;
                    appLoader.style.display = 'none';
                }, 1500);
            }
        }
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>
@import url("../../../assets/fonts/origintech-personal-use-webfont/stylesheet.css");

.course_info_page_wrp {
    padding-top: 80px;
    font-family: Arial, Helvetica, sans-serif;
    color: #e4dcdc;

    .course_info_top {
        padding: 15px;
        background: rgba(20, 26, 30, .6);
        border-radius: 3px;
        margin-bottom: 20px;

        .page_heading {
            color: #d29e00;
            font-size: 28px;
            margin-bottom: 10px;
            padding: 0px;
            font-family: "origin_tech_demoregular";
            line-height: 1;
        }

        .course_lead {
            font-size: 14px;
            color: #e4dcdc;
            line-height: 1.4;
            margin-bottom: 10px;
            text-align: justify;
        }

        .crs_label {
            margin-bottom: 10px;

            label {
                margin: 0;
                background: #eceb98;
                color: #000;
                padding: 4px 6px;
                line-height: 1;
                border-radius: 5px;
                font-size: 12px;
                font-weight: 600;
            }
        }

        .created_by {
            font-size: 14px;
            margin-bottom: 10px;

            a {
                color: #3be8b0;
            }
        }

        .actn_list {
            display: flex;
            align-items: center;

            li {
                margin-right: 10px;
                font-size: 14px;
            }
        }
    }

    .section_heading {
        font-size: 20px;
        color: #3be8b0;
        letter-spacing: 0;
        margin-bottom: 10px;
        line-height: 1;
    }

    .what_you_learn_inner {
        border: 1px solid #2b2b2b;
        padding: 15px 25px;
        border-radius: 5px;

        .what_you_learn {
            padding: 15px 0;
        }

        ul {
            padding-left: 15px;

            li {
                list-style: disc;
                font-size: 15px;
                margin-top: 10px;
            }
        }
    }

    .course_info_section_inner {
        min-height: calc(100vh - 80px);

        .content_box_wrp {
            background: rgba(0, 0, 0, 0.92);
            border-radius: 3px;
            padding: 15px;
        }

        .courses_inner_wrp {
            background: rgba(24, 24, 24, 0.7);
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            border: 1px solid #2c2b2b;
            border-radius: 5px;
            margin: 10px 0;

            .courses_img {
                padding: 5px;

                .img-fluid {
                    height: 210px;
                    border-radius: 5px;
                    width: 100%;
                    object-fit: cover;
                    object-position: center center;
                }
            }

            .courses_name {
                display: table;
                width: 100%;
                min-height: 80px;
                text-align: center;
                border-top: 0;

                span {
                    display: table-cell;
                    vertical-align: middle;
                    font-size: 20px;
                    padding: 0 15px;
                    font-weight: 600;
                    line-height: 1.3;
                }
            }

            &:hover {
                background: #fff;
                color: #000000;

                .courses_name span {
                    font-weight: bold;
                }
            }
        }
    }

    .related_topic_section {
        padding: 20px 0;

        ul {
            display: flex;

            .badge {
                border: 1px solid #3be8b0;
                font-size: 14px;
                font-weight: normal;
                padding: 5px 10px;
                margin-right: 10px;
                color: #3be8b0;
                margin-bottom: 0;
            }
        }
    }

    .course_include_features {
        padding-bottom: 20px;
        ul li{margin-top: 8px;.fa-caret-right{margin-right: 3px;}}
    }
    .course_purchase_info{
        text-align:center;
        padding-top: 30px;
        padding-bottom: 10px;
        .btn-primary{
            background: none;
            color: #fff;
            font-family: 'ACETONE';
            padding: 10px 22px;
            font-size: 28px;
            line-height: 1;
            font-weight: normal;
            text-transform: uppercase;
            border-radius: 6px;
            -webkit-transition: all .2s ease-in-out;
            transition: all .2s ease-in-out;
            border: 2px solid #3be8b0;
            color: #3be8b0;
            -webkit-box-shadow: none;
            box-shadow: none;
            &:hover{
              background: #3be8b0;
              color: #000000;
            }
        }
    }
    .courses_content{
        .card{
            border: none;
            // background:none;
            margin-bottom: 5px;
        }
        .card-header{
            background: #4f063b;
            color: #fff;
            font-size: 20px;
            padding: 8px 15px;
            -webkit-transition: all .5s ease;
            transition: all .5s ease;
            -webkit-box-shadow: none;
            box-shadow: none;
            outline: 0;
            font-weight: 400;
            cursor: pointer;
            font-family: Beon;
            word-spacing: 5px;
            h5{font-size:inherit;}
        }
        .card-body{
            color: #000000;
        }
    }
}
</style>